<template>
  <div :class="$attrs.class">
    <div class="lg:tw-flex tw-mb-12 tw-px-8" v-if="props.order">
      <div class="lg:tw-w-1/2 lg:tw-mr-8">
        <h2 class="tw-font-black tw-text-4xl" v-if="order.catering_order != null && order.catering_order.event_type">Event: {{order.catering_order.event_type}}</h2>
        <h2 class="tw-font-black tw-text-4xl" v-else></h2>

        <p class="tw-mb-4">
          {{orderDate}}
        </p>

        <h4 class="tw-text-2xl tw-font-black">{{orderHeadline}}</h4>

        <template v-if="(order.deliverymode == 'delivery' || order.deliverymode == 'dispatch') && order.delivery_street1 != null" >
          <p class="tw-mb-4">
            to {{order.delivery_street1}}
          </p>
        </template>
        <template v-else-if="orderLocation">
          <p class="tw-mb-4">
            Piada {{orderLocation.name}}<br/>
            {{orderLocation.streetaddress}}<br/>
            {{orderLocation.city}}, {{orderLocation.state}} {{orderLocation.zip}}
          </p>
        </template>

        <template v-if="order.catering_order != null && order.catering_order.contact_name != null">
          
          <h4 class="tw-text-2xl tw-font-black">Contact:</h4>
          <p>
            {{order.catering_order.contact_name}}
          </p>
        </template>

      </div>
      
      <div class="lg:tw-w-1/2 lg:tw-ml-8">
        <h2 class="tw-font-black tw-text-4xl">Guest Information</h2>

        <p class="tw-mb-4" v-if="order.catering_order != null && order.catering_order.guest_count">
          {{order.catering_order.guest_count}} 
          <!-- @vue-skip -->
          {{pluralizeProductName('guest', order.catering_order.guest_count)}}
        </p>
        <p class="tw-mb-4" v-else>
          Guest count not listed
        </p>

        <h4 class="tw-text-2xl tw-font-black">Guest Allergies</h4>
        <p class="tw-mb-4" v-if="order.catering_order != null && order.catering_order.allergens != null && order.catering_order.allergens.length > 0">
          {{order.catering_order.allergens.join(', ')}}
        </p>
        <p class="tw-mb-4" v-else>
          None listed
        </p>


        <h4 class="tw-text-2xl tw-font-black">Guest Diets</h4>
        <p class="tw-mb-4" v-if="order.catering_order != null && order.catering_order.diets != null && order.catering_order.diets.length > 0">
          {{order.catering_order.diets.join(', ')}}
        </p>
        <p class="tw-mb-4" v-else>
          None listed
        </p>
      </div>
    </div>

    <div class="tw-w-full tw-px-8" v-if="props.order">

      <table class="tw-table-fixed tw-w-full tw-mb-16">
          <tbody>
            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Order Type
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                {{order.deliverymode}}
              </td>
            </tr>

            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Order ID
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                {{order.oloid}}
              </td>
            </tr>

            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Subtotal
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order.subtotal ? order.subtotal.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00' }}
              </td>
            </tr>

            <tr v-if="order && order.tip">
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Tip
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order && order.tip ? order.tip.toLocaleString("en-US", {minimumFractionDigits: 2}) : '0.00'}}
              </td>
            </tr>

            <tr v-if="order && order.customerhandoffcharge">
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Delivery Fee
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order && order.customerhandoffcharge ? order.customerhandoffcharge.toLocaleString("en-US", {minimumFractionDigits: 2}) : '0.00'}}
              </td>
            </tr>

            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Discounts
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                <span v-if="order.discount && order.discount > 0">-</span>
                ${{order.discount ? order.discount.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00' }}
              </td>
            </tr>

            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Tax
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order.totalTaxes() ? (order.totalTaxes()).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'}}
              </td>
            </tr>
        
            <tr>
              <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
                Total
              </td>
              <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
                ${{order.total ? order.total.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00' }}
              </td>
            </tr>
          </tbody>
        </table>

      <h2 class="tw-font-black tw-text-2xl tw-mb-8">Items Ordered</h2>

      <bagProduct
        class="tw-w-full tw-mb-4 tw-bg-white tw-shadow-xl tw-rounded-2xl"
        v-for="product in order.products"
        :actions="false"
        :size="'confirmation'"
        :key="'bp-'+product.chainproductid.toString()"
        :product="product" />
    </div>
  </div>
</template>


<script setup lang="ts">
  import { ref, onMounted, computed, getCurrentInstance } from 'vue'
  import TwButton from '../../components/TwButton.vue';

  import bagProduct from '../bag/_BagProduct.vue';

  import type OrderDetails from '../../classes/OrderDetails';
  import type Location from '../../classes/Location';

  import { DateTime } from "luxon";
  const props = defineProps<{ order: OrderDetails, locations: Location[] }>();

  const orderDate = computed(() => {
    let dt = '';

    if (props.order?.readytime != null) {
      let ready = DateTime.fromFormat(props.order.readytime, 'yyyyMMdd HH:mm');

      dt = ready.toFormat('EEEE, MMM d')
    }

    return dt;
  })

  const orderLocation = computed(() => {
    let location: (Location | undefined) = undefined;

    if (props.locations && props.locations.length > 0) {
      location = props.locations.find((loc: Location) => {
        return loc.id == props.order.vendorid
      });
    }

    return location
  })

  // Not worth trying to do this one liner in the template so just concate it here
  const orderHeadline = computed(() => {
    let title = ''

    switch(props.order.deliverymode) {
      case 'pickup':
        title += 'Pick up from '
        break;
      case 'drivethru':
        title += 'Drivethru at '
        break;
      case 'curbside':
        title += 'Curbside at '
        break;
      case 'dispatch':
        title += 'Delivery from '
        break;
      default:
        title += 'Pick up from '
    }

    return title
  })

  const reorderButtonText = computed(() => {
    return "Re-Order - $" + (props.order.total).toLocaleString("en-US", {minimumFractionDigits: 2})
  })
</script>